module.exports = require("./pt-CV.d.ts");